export default __webpack_public_path__ + "static/media/electric-charging-station.5b06b1b1.svg";